import { ALGOLIA_CLIENT_TIMEOUTS } from "@/fetch/algolia/algoliaTimeouts";
import { recommendClient } from "@algolia/recommend";
import { algoliasearch } from "algoliasearch";

export const options = [
  { label: "Best Sellers", value: `net32_products` },
  { label: "Lowest Price", value: `net32_lowest_price` },
  { label: "New Arrivals", value: `net32_new_arrivals` },
  { label: "Highest Rated", value: `net32_highest_rated` },
  { label: "Percent Savings", value: `net32_percent_saving` },
];

export const defaultIndex = `net32_products`;
export const querySuggestionsIndex = `net32_products_query_suggestions`;

/**
 * Create an Algolia search client.
 * Server components: pass process.env.ALGOLIA_APP_ID / ALGOLIA_SEARCH_API_KEY.
 * Client components: pass values from useAppSelector(state => state.config).
 */
export function createSearchClient(appId: string, apiKey: string) {
  return algoliasearch(appId, apiKey, { timeouts: ALGOLIA_CLIENT_TIMEOUTS });
}

/**
 * Create an Algolia recommend client.
 * Server components: pass process.env.ALGOLIA_APP_ID / ALGOLIA_RECOMMENDATIONS_API_KEY.
 * Client components: pass values from useAppSelector(state => state.config).
 */
export function createRecommendClient(appId: string, apiKey: string) {
  return recommendClient(appId, apiKey, { timeouts: ALGOLIA_CLIENT_TIMEOUTS });
}

export const VIEW_MODE_COOKIE_NAME = "n32SearchViewMode";
export const USER_UUID_COOKIE_NAME = "n32SearchUserUuid";
